<template>
	<div>
		<v-autocomplete
			:items="
				dropdownDataSource.sort((a, b) => {
					return a[Object.keys(a)[0]].localeCompare(
						b[Object.keys(b)[0]]
					);
				})
			"
			v-model="value"
			:label="item.Label"
			clearable
			required
			:rules="[(v) => !!v || 'Is required']"
			:filter="searchDropdown"
		>
			<template v-slot:selection="data">
				{{ filterGroupByCriteriaItems(data.item) }}
			</template>
			<template v-slot:item="{ item }">
				{{ filterGroupByCriteriaItems(item) }}
			</template>
		</v-autocomplete>
	</div>
</template>
<script>
import gridViewFieldUtils from '../../../../../utils/gridViewFieldsUtils';
import { ActivityItemModalGetters } from '../../../../../store/getters';
import { mapGetters } from 'vuex';
export default {
	name: 'ActivityItemGroupByCriteria',
	props: {
		item: Object,
		listId: String,
		activityItem: Object,
	},
	data() {
		return {
			value: null,
		};
	},
	computed: {
		...mapGetters({
			groupByCriteriaValues: [
				ActivityItemModalGetters.GROUP_BY_CRITERIA_VALUES,
			],
			groupByLists: [ActivityItemModalGetters.GROUP_BY_LIST],
		}),
		dropdownDataSource() {
			if (!this.groupByCriteriaValues) return [];
			if (!this.groupByLists) return [];
			if (!this.gvfKeys.length > 0) return [];
			let result = this.groupByCriteriaValues.map((o) =>
				Object.fromEntries(this.gvfKeys.map((k) => [k, o[k]]))
			);
			return Array.from(new Set(result.map(JSON.stringify))).map(
				JSON.parse
			);
		},
		gvfKeys() {
			if (!this.selectedList) return [];
			let result = [];
			this.selectedList.GridViewFields.forEach((x) => {
				result.push(gridViewFieldUtils.getFieldName(x));
			});
			return result;
		},
		selectedList() {
			if (!this.groupByLists) return null;
			return this.groupByLists.find((x) => x.Id == this.listId);
		},
	},
	watch: {
		value(newVal) {
			this.$emit('change', newVal, this.listId);
		},
	},
	mounted() {
		let obj = null;
		if (this.activityItem.Id) {
			this.item.GridViewFields.forEach((gvf) => {
				if (
					this.activityItem.GroupByCriteria.find(
						(x) =>
							x.ActivityGroupByConditionFieldGridViewFieldId ==
							gvf.Id
					)
				) {
					obj = obj ?? {};
					obj[gridViewFieldUtils.getFieldName(gvf)] =
						this.activityItem.GroupByCriteria.find(
							(x) =>
								x.ActivityGroupByConditionFieldGridViewFieldId ==
								gvf.Id
						).Value;
				}
			});
		}
		this.value = obj;
	},
	methods: {
		searchDropdown(item, queryText) {
			let match = Object.values(item).filter((x) =>
				x.toLowerCase().includes(queryText.toLowerCase())
			);
			if (match.length > 0) return true;
			else return false;
		},
		filterGroupByCriteriaItems(item) {
			if (!this.gvfKeys.length > 0) return;
			let result = [];
			result = this.gvfKeys.map((x) => item[x]);
			return result.join(' / ');
		},
		getGroupByCriteriaValues(param) {
			if (!param) return;
			return Object.values(param).join(' / ');
		},
		onClear() {
			this.value = null;
		},
	},
};
</script>
